<template>

    <div class="planlist">

      <div class="row mt-5">

        <div class="col-2">
          <router-link to="/Plan"
                       class="btn btn-outline-primary"
                       href="#">
            <b-icon icon="caret-left" /><span class="d-none d-md-inline">&nbsp;{{ $t('message.default_zurueck') }}</span>
          </router-link>
        </div>
        <div class="col-10 text-right">

          <b-button variant="outline-primary" @click="neuenPlanHochladen()">
            <b-icon icon="upload" />&nbsp;&nbsp;{{ $t('message.planList_neu') }}
          </b-button>

        </div>

      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="content_title">

            <h1>{{ $t('message.plan_plaene') }}</h1>

            <!-- Plan Liste -->
            <div id="planliste" v-if="plaene">

              <!-- Ergebnis Tabelle Filtern -->
              <div id="filter" class="row border-top mb-3 pt-3">

                <div class="col-sm-8 col-md-11">

                  <b-input-group size="sm">

                    <b-form-input
                        v-model="keyword"
                        type="search"
                        id="filterInput"
                        :placeholder="$t('message.positionen_filter')">

                    </b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!keyword" @click="keyword = ''"><span class="oi oi-x"></span></b-button>
                      </b-input-group-append>

                    </b-input-group>

                </div>
                <div class="col-sm-4 col-md-1 text-right">

                  <b-form-group horizontal label="" class="">
                    <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
                  </b-form-group>

                </div>

              </div>

              <div class="table-responsive">
                <b-table
                  id="plan-table"
                  striped
                  small
                  :fields="fields"
                  :items="items"
                  :keyword="keyword"
                  :current-page="currentPage"
                  :per-page="perPage"
                  hover
                  :responsive="true">

                <template v-slot:cell(dateCreated)="row">
                  {{ javaDateToDateInputFieldDate(row.item.dateCreated) }}
                </template>
                <template v-slot:cell(revision)="row">
                  <span v-if="row.item.revisionsDatum">
                    {{ javaDateToDateInputFieldDate(row.item.revisionsDatum) }}
                  </span>
                </template>
                <template v-slot:cell(revisionUser)="row">
                  <span v-if="row.item.revisionUser">
                    <print-user v-model="row.item.revisionUser.id" />
                  </span>
                </template>
                <template v-slot:cell(image)="row">
                  <show-plan-thumb :plan="row.item" />
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button variant="danger" @click="deletePlan(row.item)" class="mr-2 mb-1" size="sm">
                    <b-icon icon="trash"></b-icon><span class="d-none d-md-inline">&nbsp;{{ $t('message.default_loeschen') }}</span>
                  </b-button>
                  <b-button @click="editPlan(row.item)" class="mb-1">
                    <b-icon icon="pencil"></b-icon><span class="d-none d-md-inline">&nbsp;{{ $t('message.default_aendern') }}</span>
                  </b-button>
                </template>

                <template v-slot:row-details="row">
                  <div class="m-3">
                    <label>{{ $t('message.planList_bemerkung_freigabe') }}: </label> {{ row.item.revisionBemerkung }}
                  </div>
                </template>

              </b-table>
              </div>

              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
                </b-col>
              </b-row>

            </div>
            <!-- noch keine Pläne vorhanden -->
            <div v-else-if="hasNoPlan" class="mt-5">
              <b-alert variant="warning" show>{{ $t('message.plan_empty') }}</b-alert>
            </div>
            <!-- pläne laden -->
            <b-card
                v-else
                :title="$t('message.planList_loading') + ' ...'"
                style="max-width: 20rem;"
                class="mb-2">
              <b-card-text class="text-center">
                <SpinnerImage />
              </b-card-text>
            </b-card>

          </div>
        </div>
      </div>

      <!-- Model zum Hochladen eines Plans -->
      <b-modal id="modal-upload" :title="modalUploadTitle" size="lg" hide-footer>

        <div class="my-4">

          <b-alert variant="info" show v-if="editMode">
            {{ $t('message.planList_austauschen') }}
          </b-alert>
          <b-alert variant="info" show v-else>
            {{ $t('message.planList_p') }}
          </b-alert>

          <b-form enctype="multipart/form-data">

            <b-form-group id="bezeichnung-label"
                          :label="$t('message.plan_bezeichnung') + ':*'"
                          label-for="bezeichnung">
              <b-form-input
                  id="bezeichnung"
                  v-model.trim="bezeichnung"
                  maxlength="255"
                  required
                  :placeholder="$t('message.planList_bezeichnung')"
              />
            </b-form-group>

            <!-- Plan freigeben -->
            <span v-if="editMode">

               <b-form-checkbox
                   id="checkbox-plan-freigegeben"
                   v-model="freigegeben"
                   name="checkbox-plan-freigegeben"
                   value="true"
                   unchecked-value="false">
                {{ $t('message.planList_ueberprueft') }}
              </b-form-checkbox>
              <b-form-textarea
                  id="textareaRevisionBemerkung"
                  v-model="revisionBemerkung"
                  :placeholder="$t('message.plan_bemerkungen') + ' ...'"
                  class="mt-2 mb-2"
                  rows="3" />

            </span>

            <b-form-checkbox
                id="leerer-plan"
                v-model="useEmpty"
                name="useEmpty"
                class="mb-3"
                value="true"
                unchecked-value="false">
              {{ $t('message.planList_ohne_file') }}
            </b-form-checkbox>

            <b-form-group id="file-label"
                          :label="$t('message.planList_datei') + ':*'"
                          label-for="file"
                          v-if="!editMode && useEmpty == 'false'">

              <!-- Kamera/Galerie Optionen wenn Kamera verfügbar -->
              <div v-if="hasCamera" class="mb-2">
                <b-button-group class="w-100 mb-2">
                  <b-button
                      :variant="uploadMode === 'camera' ? 'primary' : 'outline-primary'"
                      @click="openCamera()">
                    <b-icon icon="camera"></b-icon>&nbsp;Kamera
                  </b-button>
                  <b-button
                      :variant="uploadMode === 'gallery' ? 'primary' : 'outline-primary'"
                      @click="openGallery()">
                    <b-icon icon="image"></b-icon>&nbsp;Galerie
                  </b-button>
                  <b-button
                      :variant="uploadMode === 'file' ? 'primary' : 'outline-primary'"
                      @click="uploadMode = 'file'; stopCamera()">
                    <b-icon icon="file-earmark"></b-icon>&nbsp;Datei
                  </b-button>
                </b-button-group>

                <!-- Webcam Viewfinder (Desktop + Mobile) -->
                <div v-if="uploadMode === 'camera' && cameraActive" class="text-center mb-2">
                  <video ref="cameraVideo"
                         autoplay
                         playsinline
                         muted
                         class="w-100 rounded"
                         style="background: #000; display: block;"></video>
                  <canvas ref="cameraCanvas" class="d-none"></canvas>
                  <div class="mt-2">
                    <b-button variant="success" @click="takePhoto()" size="lg">
                      <b-icon icon="camera"></b-icon>&nbsp;Foto aufnehmen
                    </b-button>
                    <b-button variant="outline-secondary" @click="stopCamera()" class="ml-2">
                      Abbrechen
                    </b-button>
                  </div>
                </div>

                <!-- Hidden input für Galerie (Mobile: Bildergalerie, Desktop: Datei-Dialog für Bilder) -->
                <input
                    ref="galleryInput"
                    type="file"
                    accept="image/*"
                    class="d-none"
                    @change="onGalleryFileSelected"
                />

                <!-- Vorschau des aufgenommenen/ausgewählten Bildes -->
                <div v-if="file && uploadMode !== 'file'" class="mt-2">
                  <div class="text-center" v-if="cameraPreview">
                    <img :src="cameraPreview" class="img-thumbnail mb-2" style="max-height: 200px;" />
                  </div>
                  <b-alert variant="success" show>
                    <b-icon icon="check-circle"></b-icon>&nbsp;{{ file.name }}
                  </b-alert>
                </div>

                <!-- Datei-Upload wenn Modus 'file' -->
                <b-form-file
                    v-if="uploadMode === 'file'"
                    id="file"
                    required
                    v-model="file"
                    :state="Boolean(file)"
                    :placeholder="$t('message.planList_upload') + ' ...'"
                    :drop-placeholder="$t('message.fileUpload_einfuegen')">
                </b-form-file>
              </div>

              <!-- Standard File-Upload wenn keine Kamera -->
              <b-form-file
                  v-else
                  id="file"
                  required
                  v-model="file"
                  :state="Boolean(file)"
                  :placeholder="$t('message.planList_upload') + ' ...'"
                  :drop-placeholder="$t('message.fileUpload_einfuegen')">
              </b-form-file>

            </b-form-group>

            <b-button type="button" variant="primary" @click="saveFile()" :disabled="!editUploadFormValid" v-if="editMode">
              <b-icon icon="check2-square"></b-icon>&nbsp;{{ $t('message.default_speichern') }}
            </b-button>
            <b-button type="button" variant="primary" @click="saveNewFile()" :disabled="!uploadFormValid" v-else>
              <b-icon icon="upload"></b-icon>&nbsp;{{ $t('message.default_speichern') }}
            </b-button>

          </b-form>

        </div>

      </b-modal>

    </div>

</template>

<script>

  import axios from 'axios'
  axios.defaults.withCredentials = true
  import ShowPlanThumb from '@/components/plan/ShowPlanThumb'
  import SpinnerImage from '@/components/layout/SpinnerImage'
  import PrintUser from '@/components/benutzer/PrintUser'
  import bootbox from 'bootbox'

  export default {
    name: 'PlanList',
    components: {
      ShowPlanThumb,
      SpinnerImage,
      PrintUser,
    },
    data () {
      return {
        /** Liste mit Plänen des Kunden */
        plaene: null,
        /** Bezeichnung eines neuen Plans */
        bezeichnung: null,
        /** File der hochgeladen werden soll */
        file: null,
        /** Spalten der Planliste */
        fields: [
          {
            key: 'image',
            label: this.$t('message.planList_thumbnail'),
            sortable: false,
          },
          {
            key: 'bezeichnung',
            label: this.$t('message.plan_bezeichnung'),
            sortable: true,
          },
          {
            key: 'dateCreated',
            label: this.$t('message.planList_hochgeladen_am'),
            sortable: true,
          },
          {
            key: 'revision',
            label: this.$t('message.planList_freigegeben_am'),
            sortable: true,
          },
          {
            key: 'revisionUser',
            label: this.$t('message.planList_freigegeben_von'),
            sortable: true,
          },
          {
            key: 'actions',
            label: '',
            sortable: false,
            class: 'text-right',
          }
        ],
        /** Filter Query String für Suche nach Plänen */
        keyword: '',
        /** Anzahl der Positionen die in der Tabelle angezeigt werden sollen */
        pageOptions: [ 5, 10, 15, 20, 50, 100 ],
        /** ausgewählter Wert aus den pageOptions */
        perPage: 50,
        /** Pagination der Ergenistabelle */
        currentPage: 1,
        /** Titel des Modals für Plan Upload */
        modalUploadTitle: this.$t('message.planList_neu'),
        /** der Plan der geändert werden soll */
        editMode: null,
        /** wenn es noch keine Pläne gibt */
        hasNoPlan: null,
        /** Plan wurde freigegeben */
        freigegeben: 'false', // String da value der Checkbox
        /** Anmerkung zur Plan Freigabe */
        revisionBemerkung: null,
        /** erzeuge einen leeren Plan oder lade einen hoch */
        useEmpty: 'false',
        /** ob eine Kamera verfügbar ist */
        hasCamera: false,
        /** aktueller Upload-Modus: 'file', 'camera' oder 'gallery' */
        uploadMode: 'file',
        /** ob der Kamera-Stream aktiv ist */
        cameraActive: false,
        /** aktiver MediaStream der Kamera */
        cameraStream: null,
        /** Vorschau-URL des aufgenommenen Fotos */
        cameraPreview: null,
      }
    },
    mounted() {

      this.init()
      this.detectCamera()

      var that = this
      this.$root.$on('bv::hide::modal', (bvEvent, modalId) => {

        if (modalId == 'modal-upload') {
          that.stopCamera();
          that.file            = null
          that.bezeichnung     = null
          that.editMode        = null
          that.cameraPreview   = null
        }

      })

    },
    computed: {

      /**
       * prüft ob die UPload Form ausgefüllt wurde
       */
      uploadFormValid: function () {

        if (!this.file && this.useEmpty == 'false') return false
        if (!this.bezeichnung) return false
        return true

      },
      /** prüft ob die Upload Form valide ist für eine Plan Änderung */
      editUploadFormValid: function () {

        if (!this.bezeichnung) return false
        return true

      },
      items: function () {

        var lowercase = this.keyword ? this.keyword.toLowerCase() : null

        var selectedRows = lowercase
            ? this.plaene.filter( item =>

                (item.bezeichnung && item.bezeichnung.toLowerCase().includes(lowercase))

            )
            : this.plaene

        return selectedRows

      },
      totalRows: function () {
        return this.items.length
      }

    },
    methods: {

      /**
       * Prüft ob eine Kamera verfügbar ist (z.B. Smartphone oder Laptop-Webcam)
       */
      detectCamera: function () {
        var that = this
        if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
          navigator.mediaDevices.enumerateDevices().then(function (devices) {
            that.hasCamera = devices.some(function (device) {
              return device.kind === 'videoinput'
            })
          }).catch(function () {
            that.hasCamera = false
          })
        }
      },
      /**
       * Öffnet die Kamera (getUserMedia Video-Stream)
       */
      openCamera: function () {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          this.hasCamera = false
          this.uploadMode = 'file'
          return
        }
        this.uploadMode = 'camera'
        this.file = null
        this.cameraPreview = null
        var that = this
        navigator.mediaDevices.getUserMedia({
          video: { facingMode: { ideal: 'environment' } }
        }).then(function (stream) {
          that.cameraStream = stream
          that.cameraActive = true
          that.startVideoStream()
        }).catch(function (err) {
          console.log('Kamera-Zugriff fehlgeschlagen: ' + err)
          that.cameraActive = false
          that.uploadMode = 'file'
        })
      },
      /**
       * Verbindet den Kamera-Stream mit dem Video-Element.
       * Wartet bis das v-if-Element tatsächlich gerendert ist.
       */
      startVideoStream: function (retries) {
        if (retries === undefined) retries = 10
        var that = this
        this.$nextTick(function () {
          var video = that.$refs.cameraVideo
          if (video) {
            video.srcObject = that.cameraStream
            video.onloadedmetadata = function () {
              video.play().catch(function () {})
            }
          } else if (retries > 0) {
            setTimeout(function () {
              that.startVideoStream(retries - 1)
            }, 50)
          }
        })
      },
      /**
       * Foto aufnehmen vom Video-Stream
       */
      takePhoto: function () {
        var video = this.$refs.cameraVideo
        var canvas = this.$refs.cameraCanvas
        if (!video || !canvas) return

        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        canvas.getContext('2d').drawImage(video, 0, 0)

        var that = this
        canvas.toBlob(function (blob) {
          var timestamp = new Date().toISOString().replace(/[:.]/g, '-')
          that.file = new File([blob], 'foto-' + timestamp + '.jpg', { type: 'image/jpeg' })
          that.cameraPreview = canvas.toDataURL('image/jpeg')
          that.stopCamera()
        }, 'image/jpeg', 0.92)
      },
      /**
       * Kamera-Stream stoppen
       */
      stopCamera: function () {
        if (this.cameraStream) {
          this.cameraStream.getTracks().forEach(function (track) {
            track.stop()
          })
          this.cameraStream = null
        }
        this.cameraActive = false
      },
      /**
       * Öffnet die Galerie/Bildauswahl
       */
      openGallery: function () {
        this.uploadMode = 'gallery'
        this.file = null
        this.cameraPreview = null
        this.stopCamera()
        this.$nextTick(function () {
          this.$refs.galleryInput.click()
        })
      },
      /**
       * Callback wenn Bild über Galerie ausgewählt wurde
       */
      onGalleryFileSelected: function (event) {
        var files = event.target.files
        if (files && files.length > 0) {
          this.file = files[0]
          this.cameraPreview = URL.createObjectURL(files[0])
        }
      },
      /**
       * Modal öffnen um neuen Plan hochzuladen
       */
      neuenPlanHochladen: function () {

        this.bezeichnung        = null
        this.file               = null
        this.modalUploadTitle   = this.$t('message.planList_hochladen')
        this.editMode           = null
        this.freigegeben        = 'false'
        this.revisionBemerkung  = null
        this.useEmpty           = 'false'
        this.uploadMode         = 'file'

        this.$bvModal.show('modal-upload')

      },
      /** holt alle Pläne des Kunden */
      init: function () {

        if (this.$store.getters.customer) {

          var that = this
          var url = process.env.VUE_APP_SERVER_URL + '/plan/index'
          const mandant  = typeof this.$store.getters.customer.biotechCountry === "string" ? this.$store.getters.customer.biotechCountry : this.$store.getters.customer.biotechCountry.name
          var params = {
            'bezeichnung': this.bezeichnung,
            'cardcode':    this.$store.getters.customer.cardcode,
            'mandant':     mandant,
          };
          // speichere File in Filesystem
          axios({
            method: 'GET',
            url: url,
            params: params,
            withCredentials: true
          }).then(function (daten) {

            if (daten.data) {

              that.plaene = daten.data
              if (!that.plaene || that.plaene.length < 1) {
                that.hasNoPlan = true
              } else if (that.plaene.length > 0) {

                that.hasNoPlan = false

                // zeige detailsShowing wenn Bemerkung vorhanden  ist
                var newlist = [];
                for (var i = 0; i < that.plaene.length; i++) {
                  if (that.plaene[i].revisionBemerkung) {
                    that.plaene[i]._showDetails = true
                  }
                  newlist.push(that.plaene[i])
                }
                that.plaene = newlist

              }

            }

          }).catch(error => {

            console.log('Fehler beim Lesen der Pläne: ' + error)

          });

        }

      },
      /** Plan löschen */
      deletePlan: function (plan) {

        var that = this;
        var text = this.$t('message.planList_loeschen').replace('{0}', plan.bezeichnung);
        bootbox.confirm(text, function (result) {
          if (result) {

            var url     = process.env.VUE_APP_SERVER_URL + '/plan/delete'
            var params  = {
              plan_id: plan.id
            };
            axios ({
              method: 'GET',
              params: params,
              url: url,
            }).then(function (response) {

              if (response.data.id) {
                var newlist = []
                for (var i = 0; i < that.plaene.length; i++) {
                  if (that.plaene[i].id != plan.id) {
                    newlist.push(that.plaene[i])
                  }
                }
                that.plaene = newlist
              }

            });

          }
        })

      },
      /** Modal öffnen um Plan zu ändern */
      editPlan: function (plan) {

        // Zuerset öffnen, dann Werte setzen
        this.$bvModal.show('modal-upload')

        this.bezeichnung        = plan.bezeichnung
        this.file               = null
        this.modalUploadTitle   = 'Plan ändern'
        this.editMode           = plan
        this.freigegeben        = plan.revisionsDatum ? 'true' : 'false'
        this.revisionBemerkung  = plan.revisionBemerkung

      },
      /**
       * Plan ändern
       */
      saveFile: function () {

        var formData = new FormData()
        if (this.file) {
          formData.append('file', this.file)
        }

        this.showSpinner()

        // File an Server senden
        var that = this
        var url = process.env.VUE_APP_SERVER_URL + '/plan/edit'
        var params = {
          'bezeichnung':        this.bezeichnung,
          'plan_id':            this.editMode.id,
          'revisionBemerkung':  this.revisionBemerkung,
          'freigegeben':        this.freigegeben,
        };
        // speichere File in Filesystem
        axios({
          method: 'post',
          url: url,
          params: params,
          withCredentials: true,
          contentType: 'multipart/form-data',
          data: formData,
        }).then(function (daten) {

          console.log('File erfolgreich geändert: ' + daten)

          try {
            if (daten.data.id) {

              var newlist = [];
              for (var i = 0; i < that.plaene.length; i++) {
                if (that.plaene[i].id == that.editMode.id) {
                  if (daten.data.revisionBemerkung) {
                    daten.data._showDetails = true
                  }
                  newlist.push(daten.data)
                } else {
                  newlist.push(that.plaene[i])
                }
              }
              that.plaene = newlist

              that.hideSpinner()

            }
          } catch(e) {
            console.log('Fehler beim Updaten der Planliste ' + e)
          }

        }).catch(error => {

          console.log('Upload Error: ' + error)
          bootbox.alert(this.$t('message.planList_error'))
          that.hideSpinner()

        });

        this.$bvModal.hide('modal-upload')

      },
      /**
       * neuen Plan speichern
       */
      saveNewFile: function () {

        console.log('save new file ' + this.file)

        try {

          var formData = new FormData();
          formData.append('file', this.file)

          this.showSpinner()

          // File an Server senden
          var that = this
          var url = process.env.VUE_APP_SERVER_URL + '/plan/upload'
          const mandant  = typeof this.$store.getters.customer.biotechCountry === "string" ? this.$store.getters.customer.biotechCountry : this.$store.getters.customer.biotechCountry.name
          var params = {
            'bezeichnung': this.bezeichnung,
            'cardcode':    this.$store.getters.customer.cardcode,
            'mandant':     mandant,
            'useEmpty':    this.useEmpty,
          };
          // speichere File in Filesystem
          axios({
            method: 'post',
            url: url,
            params: params,
            withCredentials: true,
            contentType: 'multipart/form-data',
            data: formData
          }).then(function (daten) {

            console.log('File erfolgreich hochgeladen: ', daten)

            if (daten.data.id) {

              if (!that.plaene) that.plaene = []
              that.plaene.unshift(daten.data)
              that.$bvModal.hide('modal-upload')
              that.hideSpinner()

            }

          }).catch(function(error) {

            console.log('Upload Error: ', error)
            that.$bvModal.hide('modal-upload')
            bootbox.alert(that.$t('message.planList_error'))
            that.hideSpinner()

          })

        } catch (e) {
          console.log('Error Upload new file ' + e)
        }

      } // end upload new file

    }
  }

</script>